import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  format(event) {
    const input = event.target
    const previousValue = input.value
    const previousCaret = input.selectionStart

    const digits = previousValue.replace(/\D/g, "").slice(0, 10)
    const formatted = this.applyMask(digits)

    input.value = formatted

    const digitsBeforeCaret = previousValue.slice(0, previousCaret).replace(/\D/g, "").length
    const newCaret = this.caretForDigitIndex(digitsBeforeCaret)
    input.setSelectionRange(newCaret, newCaret)
  }

  applyMask(digits) {
    if (digits.length === 0) return ""
    if (digits.length <= 3) return `(${digits}`
    if (digits.length <= 6) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`
  }

  caretForDigitIndex(n) {
    if (n === 0) return 0
    if (n <= 3) return 1 + n
    if (n <= 6) return 6 + (n - 3)
    return 11 + (n - 6)
  }
}
